/**
 * Workspace Recent Route - View recently updated items
 *
 * Shows items updated in the last 7 days.
 * Part of the Data Workspace OS feature set.
 */

import { createFileRoute } from '@tanstack/react-router';

import { WorkspacePage } from '@/features/workspace';
import { workspaceSearchSchema } from '@/features/workspace/utils/workspaceSearchSchema';

export const Route = createFileRoute('/_authenticated/_withWorkspace/workspace/recent')({
  component: WorkspaceRecentPage,
  validateSearch: workspaceSearchSchema,
});

function WorkspaceRecentPage() {
  const search = Route.useSearch();

  // Data fetching is handled by useWorkspaceItems via TanStack Query
  // No manual fetch calls needed - queries auto-fetch on mount

  return (
    <WorkspacePage
      showRecent
      searchParams={search}
    />
  );
}
